import { FlightWizardState } from "src/stores/wizard/state";
import { travelersMetadata } from "src/components/shared/TravelersField/utils";
import { TravelersMetadata } from "src/components/shared/TravelersField/typings";
import { mapFlightTripType, mapTravelDate } from "./WizardStateMapper";
import { IntentMediaPropsFlights } from "src/components/utility/Ads/IntentMedia/mappers/typings";

export function mapFlightWizardState(state: FlightWizardState): IntentMediaPropsFlights {
  const mappedTravelersMetaData: TravelersMetadata = travelersMetadata(state.travelers.nonHotel);

  return {
    page_id: "homepage.flights",
    trip_type: mapFlightTripType(state.flightTripType),
    travel_date_start: mapTravelDate(state.date.start),
    travel_date_end: mapTravelDate(state.date.end),
    travelers:
      mappedTravelersMetaData.numOfAdults +
      mappedTravelersMetaData.numOfChildren +
      mappedTravelersMetaData.numOfInfants,
    origin_airport: state.location.origin.metaData.ttla,
    origin_country: state.location.origin.metaData.countryCode,
    destination_airport: state.location.destination.metaData.ttla,
    destination_country: state.location.origin.metaData.countryCode,
    adults: mappedTravelersMetaData.numOfAdults,
    children: mappedTravelersMetaData.numOfChildren + mappedTravelersMetaData.numOfInfants,
    trigger_exit_unit: "Y",
  };
}
